import { createContext, useContext, useMemo, useRef } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";
import { getFooter, updateFooter } from "../../api/footer";

import { generatePayload, getIntialValues } from "./helper";
const PageContext = createContext();

export const PageProvider = ({ children }) => {
   const userImagesArray = useRef();
  const toaster = useToaster();

  const getFooterQuery = useQuery({
    queryKey: [""],
    queryFn: getFooter,
  });

  const updateFooterQuery = useMutation({ mutationFn: updateFooter });

  const initialValues = useMemo(() => {
    const homeData = getFooterQuery?.data?.data?.data?.[0] || {};

    return getIntialValues(homeData.page_content);
  }, [getFooterQuery]);

  const handleSubmit = async (values) => {
    const payload = generatePayload(values);
    const homeData = getFooterQuery?.data?.data?.data?.[0] || {};

    updateFooterQuery.mutate(
      { page_content: payload, id: homeData.id },
      {
        onSuccess: () => {
          toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY);
          getFooterQuery.refetch();
        },
      },
    );
    return;
  };


   const handleUserImagesAdd = () => {
    userImagesArray.current.push({ image_url: "" , social_url :"",});
  };

  const handleUserImagesDelete = (index) => () => {
    userImagesArray.current.remove(index);
  };

  return (
    <PageContext.Provider
      value={{
        initialValues,
        handleSubmit,
        getFooterQuery,
        userImagesArray,
        handleUserImagesAdd,
        handleUserImagesDelete,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};
export const usePageProvider = () => {
  return useContext(PageContext);
};
